(function () {
  const EMPTY_BUNDLE_BUTTON_TEXT = (window.buddyTranslations?.bundle?.chooseFlavours) || 'Choisis tes saveurs';
  let currentBundleState = { items: [], totalCents: 0, totalCombinedCents: 0 };
  let bundleFormId = null;

  function isBundleMode() {
    return !!document.querySelector('.flavour-grid');
  }

  function getBundleItems() {
    const result = [];
    console.log('[BundleATC] currentBundleState.items:', JSON.stringify(currentBundleState.items));
    currentBundleState.items
      .filter(item => item.quantity > 0)
      .forEach(item => {
        const card = document.querySelector(`.flavour-card[data-variant-id="${item.variantId}"]`);
        if (card && card.dataset.cardType === 'discovery') {
          const discoveryVariants = JSON.parse(card.dataset.discoveryVariants || '{}');
          const discoveryAvailability = JSON.parse(card.dataset.discoveryAvailability || '{}');
          const resolved = resolveDiscoveryPacks(item.quantity, discoveryVariants, discoveryAvailability);
          resolved.forEach(r => result.push(r));
        } else {
          result.push({ id: parseInt(item.variantId, 10), quantity: item.quantity });
        }
      });
    console.log('[BundleATC] result items to cart:', JSON.stringify(result));
    return result;
  }

  function getAtcButtons() {
    if (!bundleFormId) return [];
    return [
      ...document.querySelectorAll(`form[id="${bundleFormId}"] button[type="submit"]`),
      ...document.querySelectorAll(`buy-buttons[form="${bundleFormId}"] button[type="submit"]`)
    ].filter((btn, i, arr) => arr.indexOf(btn) === i);
  }

  function disableAtcButton(disabled) {
    getAtcButtons().forEach(btn => {
      btn.disabled = disabled;
      btn.style.opacity = disabled ? '0.4' : '';
      btn.style.cursor = disabled ? 'not-allowed' : '';
      btn.style.pointerEvents = disabled ? 'none' : '';

      const findTextContainer = (btnEl) => {
        for (const child of btnEl.children) {
          const text = child.textContent.trim();
          const isLoaderOrIcon = child.classList.contains('button__loader')
                              || child.classList.contains('button__icon')
                              || child.tagName === 'SVG';
          if (text.length > 0 && !isLoaderOrIcon) {
            return child;
          }
        }
        for (const node of btnEl.childNodes) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
            return node;
          }
        }
        return null;
      };

      if (disabled) {
        if (!btn.dataset.originalText) {
          const textContainer = findTextContainer(btn);
          if (textContainer) {
            btn.dataset.originalText = textContainer.textContent.trim();
            const isTextNode = textContainer.nodeType === Node.TEXT_NODE;
            textContainer.textContent = isTextNode ? ` ${EMPTY_BUNDLE_BUTTON_TEXT} ` : EMPTY_BUNDLE_BUTTON_TEXT;
          }
        } else {
          const textContainer = findTextContainer(btn);
          if (textContainer && !textContainer.textContent.includes(EMPTY_BUNDLE_BUTTON_TEXT)) {
            const isTextNode = textContainer.nodeType === Node.TEXT_NODE;
            textContainer.textContent = isTextNode ? ` ${EMPTY_BUNDLE_BUTTON_TEXT} ` : EMPTY_BUNDLE_BUTTON_TEXT;
          }
        }
      } else {
        if (btn.dataset.originalText) {
          const textContainer = findTextContainer(btn);
          if (textContainer) {
            const isTextNode = textContainer.nodeType === Node.TEXT_NODE;
            textContainer.textContent = isTextNode ? ` ${btn.dataset.originalText} ` : btn.dataset.originalText;
          }
          delete btn.dataset.originalText;
        }
      }
    });
  }

  function getSellingPlan() {
    const input = document.querySelector('input[name="selling_plan"]');
    return input?.value || null;
  }

  function initBundleAtc() {
    if (!isBundleMode()) return;

    const mainSection = document.querySelector('.shopify-section--main-product');
    const form = mainSection?.querySelector('form[is="product-form"]');
    if (!form || form.dataset.bundleAtcInitialized) return;
    bundleFormId = form.getAttribute('id');
    form.dataset.bundleAtcInitialized = 'true';

    disableAtcButton(true);

    document.addEventListener('bundle:items-updated', (e) => {
      currentBundleState = e.detail;
      disableAtcButton(currentBundleState.totalCents === 0);
    });

    form.addEventListener('submit', (e) => {
      if (!isBundleMode()) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const bundleItems = getBundleItems();
      if (bundleItems.length === 0) return;

      const sellingPlan = getSellingPlan();
      const items = bundleItems.map(item => ({
        ...item,
        ...(sellingPlan ? { selling_plan: parseInt(sellingPlan, 10) } : {})
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(async (addResponse) => {
          const cartDrawerEl = document.querySelector('cart-drawer');
          const sectionWrapper = cartDrawerEl?.closest('.shopify-section');
          const dynamicSectionId = sectionWrapper?.id?.replace('shopify-section-', '') || 'cart-drawer';

          const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
          const cartData = await (await fetch(cartUrl)).json();

          if (window.BundleState && cartData.original_total_price !== undefined) {
            window.BundleState.cartSubtotalCents = cartData.original_total_price;
            document.dispatchEvent(new CustomEvent('bundle:cart-loaded'));
          }

          const sectionUrl = `${window.Shopify?.routes?.root || '/'}?section_id=${encodeURIComponent(dynamicSectionId)}`;
          let sectionHtml = '';
          try {
            sectionHtml = await (await fetch(sectionUrl)).text();
          } catch (e) {
            console.warn('[Bundle ATC] Section fetch failed:', e);
          }

          const cartContent = {
            ...cartData,
            sections: {
              [dynamicSectionId]: sectionHtml
            }
          };

          const addedItems = addResponse.hasOwnProperty('items') ? addResponse['items'] : [addResponse];

          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: addedItems, cart: cartContent }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          }));

          document.dispatchEvent(new CustomEvent('skio::added-to-cart', {
            bubbles: true,
            detail: { items }
          }));
        })
        .catch(err => console.error('Bundle ATC error:', err));
    }, { capture: true });
  }

  document.addEventListener('DOMContentLoaded', initBundleAtc);
  document.addEventListener('product:rendered', initBundleAtc);
})();
